import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';

import { Patient } from '@lib/resources/types';

import {
  IconButtonReminderActions as IconButtonReminderActionsUI,
  IconButtonReminderActionsProps as IconButtonReminderActionsPropsUI,
} from 'components/v2';

import { IconButtonReminderActions_Reminder$key } from './__generated__/IconButtonReminderActions_Reminder.graphql';

export interface IconButtonReminderActionsProps extends Omit<IconButtonReminderActionsPropsUI, 'classes' | 'reminder'> {
  fragmentRef: IconButtonReminderActions_Reminder$key;
}

const IconButtonReminderActions: React.FC<IconButtonReminderActionsProps> = ({ fragmentRef, ...rest }) => {
  const reminder = useFragment<IconButtonReminderActions_Reminder$key>(
    graphql`
      fragment IconButtonReminderActions_Reminder on Reminder {
        _id
        sendAt
        patient {
          _id
        }
        oid_appointment
      }
    `,
    fragmentRef,
  );

  const cleanReminder = {
    _id: get(reminder, '_id') as string,
    sendAt: get(reminder, 'sendAt') as string,
    oid_appointment: get(reminder, 'oid_appointment') as string,
    patient: get(reminder, 'patient') as Partial<Patient>,
  };

  return <IconButtonReminderActionsUI reminder={cleanReminder} {...rest} />;
};

export default IconButtonReminderActions;
